export default __webpack_public_path__ + "static/guitar-a9cfc9539fffe2e20877f1ebec1920bc.png";